import styled from 'styled-components';

const StudentInvitationAcceptedContainer = styled.main``;

export default StudentInvitationAcceptedContainer;
